import { styled, Box } from '@/theme/index';

export const AlertTag = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '0',
  left: '0',
  borderRadius: '4px 0 4px 0',
  padding: theme.spacing(0.5, 1),
}));
